import * as React from 'react';
import { Layout, Menu } from 'antd';
import { LogoutOutlined, TeamOutlined } from '@ant-design/icons';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../actions';
import logo from '../assets/logo.png';
import useWindowDimensions from '../hooks/useWindowDimensions';

const { Sider } = Layout;

export default function LayoutSider() {
  const { height, width } = useWindowDimensions();

  const [collapsed, setCollapsed] = React.useState(width > 768 ? false : true);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const onCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed);
  };

  return (
    <Sider
      width={300}
      className="site-layout-background"
      collapsible
      collapsed={collapsed}
      collapsedWidth={0}
      onCollapse={onCollapse}
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={[location.pathname]}
        defaultOpenKeys={['sub1']}
        style={{ height: '100%', borderRight: 0 }}
      >
        <img src={logo} alt="PIC" className="logo" />

        {/* <Menu.Item key="/" icon={<CalendarOutlined />}>
          <a
            onClick={() => {
              history.push('/');
            }}
          >
            Calendar
          </a>
        </Menu.Item> */}

        <Menu.Item key="/" icon={<TeamOutlined />}>
          <a
            onClick={() => {
              history.push('/');
            }}
          >
            Students
          </a>
        </Menu.Item>

        <Menu.Item key="/logout" icon={<LogoutOutlined />}>
          <a
            onClick={() => {
              dispatch(logoutUser());
            }}
          >
            Log Out
          </a>
        </Menu.Item>
      </Menu>
    </Sider>
  );
}
